export const GENERATED_ARTIFACT_DEMO_HTML = `<!doctype html>
<html lang="en">
<head>
  <meta charset="utf-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1" />
  <title>Generated App</title>
  <style>
    body { margin: 0; font-family: Inter, system-ui; background: #111827; color: white; }
    main { min-height: 100vh; display: grid; place-items: center; padding: 32px; }
    section { max-width: 760px; padding: 40px; border-radius: 24px; background: rgba(255,255,255,.1); }
    h1 { font-size: clamp(34px, 7vw, 72px); margin: 0 0 16px; }
    p { color: rgba(255,255,255,.78); font-size: 18px; line-height: 1.6; }
    button { border: 0; border-radius: 999px; padding: 12px 18px; font-weight: 700; }
  </style>
</head>
<body>
  <main>
    <section>
      <h1>Launch-ready web app</h1>
      <p>A responsive generated interface with accessible structure and polished defaults.</p>
      <button type="button">Explore preview</button>
    </section>
  </main>
</body>
</html>`
